import { render, staticRenderFns } from "./admin.vue.html?vue&type=template&id=590b4ddc&"
import script from "./admin.ts?vue&type=script&lang=ts&"
export * from "./admin.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports